import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { IOperadora } from '../types/IGetPlanosResponse';
import { IPlano } from '../types/IPlano';

@Injectable({ providedIn: 'root' })
export class PlanoState {
  private _planoSelecionado: IPlano | null = null;
  private planoSelecionado = new BehaviorSubject<IPlano | null>(null);
  private planos: IOperadora[] | null = null;
  private requestingPlanos: boolean = true;

  selectPlano(plano: IPlano) {
    this.planoSelecionado.next(plano);
  }

  selectOriginalPlano(plano: IPlano) {
    this._planoSelecionado = plano;
    this.planoSelecionado.next(plano);
  }

  clearFilter() {
    this.planoSelecionado.next(this._planoSelecionado);
  }

  getPlanoSelecionado() {
    return this.planoSelecionado.getValue();
  }

  observePlanoSelecionado() {
    return this.planoSelecionado.asObservable();
  }

  setPlanos(planos: IOperadora[]) {
    this.planos = planos;
  }

  getPlanos() {
    return this.planos;
  }

  setIsRequestingPlanos(isRequestingPlanos: boolean) {
    this.requestingPlanos = isRequestingPlanos;
  }

  isRequestingPlanos() {
    return this.requestingPlanos;
  }

  filterByUf(ufDescription: string) {
    if(this.getPlanoSelecionado()) {
      const planoSelecionado = {...this._planoSelecionado};
  
      planoSelecionado.produtos = planoSelecionado.produtos.filter(produto => {
        if(!produto.ufs)
          return true;
        else
          return produto.ufs?.includes(ufDescription);
      });
  
      this.selectPlano(planoSelecionado);
    }
  }
}